module.exports = __webpack_public_path__ + "assets/smart-asset-calendar.a7d32579.svg";